/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AddressRequest {
  first_line?: string;
  second_line?: string;
  third_line?: string;
  post_code?: string;
  city?: string;
  county?: string;
  country?: string;
}
